// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../scalars/Scalars.bs.js");
var TanDate = require("../../reason/common/types/TanDate.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Core__Ordering = require("@rescript/core/src/Core__Ordering.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyPageNextShowing_showing_graphql = require("../../__generated__/PropertyPageNextShowing_showing_graphql.bs.js");

var convertFragment = PropertyPageNextShowing_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageNextShowing_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageNextShowing_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, PropertyPageNextShowing_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageNextShowing_showing_graphql.node, convertFragment, fRef);
}

var ShowingFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function dateTimeToUnzonedDate(dateTime) {
  return UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(dateTime));
}

function PropertyPage__NextShowing(props) {
  var timezone = props.timezone;
  var showings = use(props.showings);
  var nextShowing = Core__Option.getOr(Core__Option.map((function (arr) {
                  arr.sort(function (a, b) {
                        return Core__Ordering.fromInt(dateTimeToUnzonedDate(a.startDate).getTime() - dateTimeToUnzonedDate(b.startDate).getTime() | 0);
                      });
                  return arr;
                })(showings.filter(function (showing) {
                        return DateFns.isAfter(dateTimeToUnzonedDate(showing.startDate), TanDate.now());
                      }).slice())[0], (function (showing) {
              return DateFns.format(UTCDate.toZonedDate(Scalars.DateTime.toUTC(showing.startDate), timezone), "MMM d 'at' h:mm a");
            })), "None scheduled");
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "Next showing",
                      className: "text-zinc-500 uppercase font-medium"
                    }),
                JsxRuntime.jsx("div", {
                      children: nextShowing,
                      className: "text-lg font-medium"
                    })
              ],
              className: "space-y-2"
            });
}

var make = PropertyPage__NextShowing;

exports.ShowingFragment = ShowingFragment;
exports.dateTimeToUnzonedDate = dateTimeToUnzonedDate;
exports.make = make;
/* Scalars Not a pure module */
